import { useState } from "react";
import { Menu } from "lucide-react";
import Sidebar, { SidebarContent } from "@/components/Sidebar";
import { Sheet, SheetContent, SheetTrigger, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { CLINIC } from "@/lib/brand";

export default function DashboardLayout({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="min-h-screen flex bg-[color:var(--bg-dashboard)]"
      data-testid="dashboard-layout"
    >
      {/* Desktop sidebar */}
      <Sidebar />

      <main className="flex-1 min-w-0 flex flex-col">
        {/* Mobile top app bar */}
        <header
          className="md:hidden sticky top-0 z-30 flex items-center justify-between px-4 h-14 bg-white border-b border-[color:var(--border)]"
          data-testid="mobile-topbar"
        >
          <div className="flex items-center gap-3 min-w-0">
            <img
              src={CLINIC.logoUrl}
              alt={CLINIC.name}
              className="w-8 h-8 rounded-full object-cover ring-1 ring-[color:var(--primary-light)]"
            />
            <p className="font-heading text-sm font-medium text-[color:var(--ink)] truncate">
              {CLINIC.shortName}
            </p>
          </div>

          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button
                aria-label="Open navigation"
                className="p-2 -mr-2 rounded-lg text-[color:var(--ink)] hover:bg-[color:var(--bg-marketing)]"
                data-testid="mobile-menu-btn"
              >
                <Menu className="w-5 h-5" strokeWidth={1.8} />
              </button>
            </SheetTrigger>
            <SheetContent
              side="left"
              className="p-0 w-72 max-w-[85vw] bg-white"
              data-testid="mobile-sidebar-sheet"
            >
              <SheetTitle className="sr-only">Navigation</SheetTitle>
              <SheetDescription className="sr-only">
                Primary navigation menu
              </SheetDescription>
              <SidebarContent onNavigate={() => setOpen(false)} />
            </SheetContent>
          </Sheet>
        </header>

        <div className="flex-1 overflow-x-hidden">
          <div className="px-4 sm:px-5 md:px-10 py-6 md:py-10 max-w-[1400px] mx-auto fade-up">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
}
